import { CustomerBloc } from './../../bloc/customer.bloc';
import { TransformApiResponseDTO } from './../../dto/api/api-response.dto';
import { AuthService } from './../../services/auth/auth.service';
import { RegisterUser } from './../../dto/auth/auth.dto';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-agent',
  templateUrl: './register-agent.component.html',
  styleUrls: ['./register-agent.component.css'],
})
export class RegisterAgentComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private customerBloc: CustomerBloc
  ) {}

  registerAgentForm = new FormGroup({
    accountEmail: new FormControl('', Validators.required),
    accountName: new FormControl('', Validators.required),
    accountPhone: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    passwordConfirmation: new FormControl('', Validators.required),

    bussinessName: new FormControl('', Validators.required),
    bussinessPhone: new FormControl('', Validators.required),
    basedCurrency: new FormControl('', Validators.required),
    country: new FormControl('', Validators.required),
    province: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    address: new FormControl('', Validators.required),
    postalCode: new FormControl(''),
    confirmRegister: new FormControl('', Validators.required),
  });

  countriesData: any;
  provinceData: any;
  cityData: any;

  currenciesData: any;

  disableProvince: boolean;
  disableCity: boolean;

  thanksPage: boolean;
  confirmed: boolean;

  preloader: boolean;

  async ngOnInit(): Promise<void> {
    window.scrollTo(0, 0);
    this.thanksPage = false;
    this.disableProvince = true;
    this.disableCity = true;

    await this.getCountries();
    await this.getCurrencies();
  }

  async getCurrencies() {
    this.currenciesData = [];
    const results = await this.customerBloc.getBaseCurrency();
    if (results) {
      for (const data of results) {
        this.currenciesData.push({
          optionId: data.code,
          optionTitle: `${data.code} - ${data.name}`,
        });
      }
    }
  }

  async getCountries() {
    this.countriesData = [];
    const results = await this.customerBloc.getCountries();
    if (results) {
      for (const data of results) {
        this.countriesData.push({
          optionId: data.uuid,
          optionTitle: data.name,
        });
      }
    }
  }

  async getProvinces(param: any) {
    this.provinceData = [];
    const results = await this.customerBloc.getProvinces(param);
    if (results) {
      for (const data of results) {
        this.provinceData.push({
          optionId: data.uuid,
          optionTitle: data.name,
        });
      }
    }
  }

  async getCities(param: any) {
    this.cityData = [];
    const results = await this.customerBloc.getCities(param);
    if (results) {
      for (const data of results) {
        this.cityData.push({
          optionId: data.uuid,
          optionTitle: data.name,
        });
      }
    }
  }

  async changeCountry(event) {
    const value = event[0].value;
    if (String(value) !== '0' && String(value) !== '') {
      const param = {
        countryUuid: value,
      };
      await this.getProvinces(param);
    }
  }

  async changeProvince(event) {
    const value = event[0].value;
    if (String(value) !== '0' && String(value) !== '') {
      const param = {
        provinceUuid: value,
      };
      await this.getCities(param);
    }
  }

  get validating() {
    return this.registerAgentForm.controls;
  }

  navigated(str: string) {
    this.router.navigate([str]);
  }

  async onSubmit() {}

  async registerPost(
    registerUser: RegisterUser
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.authService.registerUser(registerUser).subscribe(
        (result) => {
          const returnData = {
            error: false,
            message: result.message,
          };
          resolve(returnData);
        },
        (error) => {
          const returnData = {
            error: true,
            message: error.message,
          };
          resolve(returnData);
        }
      );
    });
  }

  confirRegister(event) {
    this.confirmed = event.target.checked;
  }
}
